// extracted by mini-css-extract-plugin
export default {"card":"serviceCard_card__rTIU3","active":"serviceCard_active__v4phe"};